import AlertBanner, {
  AlertBannerProps
} from "@bmi-digital/components/alert-banner";
import classnames from "classnames";
import React from "react";
import { Root, classes } from "./_Alert.styles";

type AlertProps = Omit<AlertBannerProps, "severity"> & {
  type?: "info" | "warning";
  first?: boolean;
  last?: boolean;
  title: string;
};

const Alert = ({
  type = "info",
  title,
  first,
  last,
  children,
  closeButtonProps
}: AlertProps) => (
  <Root className={classnames(first && classes.first, last && classes.last)}>
    <AlertBanner severity={type} closeButtonProps={closeButtonProps}>
      <AlertBanner.Title>{title}</AlertBanner.Title>
      {children}
    </AlertBanner>
  </Root>
);

export default Alert;
